// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"8429e20170aece0ed1c0","342":"f7568be87e83ea3705ff"}[chunkId] + ".js";
};